// eslint-disable-next-line import/no-cycle
import AccordionItem from './AccordionEntry';

export default AccordionItem;
